import React, {useState} from 'react';
import PropTypes from 'prop-types';
import { PencilSquareIcon } from '@heroicons/react/24/outline';
import { OutlineButton, SolidButton } from '@/components/Button';
import StringField from '@/forms/_fields_v2/StringField';
import TextAreaField from '@/forms/_fields_v2/TextAreaField';

EditableString.propTypes = {
  label: PropTypes.node.isRequired,
  value: PropTypes.string,
  isEditing: PropTypes.bool,
  onEdit: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  saveDisabled: PropTypes.bool,
  editAriaLabel: PropTypes.string,
  fieldType: PropTypes.oneOf(['string', 'textarea'])
};

export default function EditableString(props) {
  const {
    label,
    value,
    isEditing,
    onEdit,
    onChange,
    onCancel,
    onSave,
    saveDisabled = false,
    editAriaLabel = 'Edit field',
    fieldType = 'string'
  } = props;

  const [isSaving, setIsSaving] = useState(false);


  const FieldComponent = fieldType === 'textarea' ? TextAreaField : StringField;

  async function handleSave() {
    setIsSaving(true);
    try {
      await onSave();
    } finally {
      setIsSaving(false);
    }
  }

  return (
    <div>
      <div className="mb-2 flex items-center space-x-3">
        <h4 className="text-base font-semibold text-cs-gray-900">{label}</h4>
        <button
          type="button"
          className="text-cs-blue-500 hover:opacity-60"
          onClick={onEdit}
          aria-label={editAriaLabel}
        >
          <PencilSquareIcon className="size-5" />
        </button>
      </div>
      {isEditing ? (
        <>
          <FieldComponent
            value={value}
            onChange={onChange}
            border={false}
            shadow={false}
            focus={false}
          />
          <div className="mt-4 flex items-center justify-between">
            <OutlineButton label="Cancel" onClick={onCancel} disabled={isSaving}/>
            <SolidButton label="Save" onClick={handleSave} disabled={isSaving || saveDisabled} />
          </div>
        </>
      ) : (
        <p className="text-base text-cs-gray-500">{value}</p>
      )}
    </div>
  );
}
